window.ltiPBWindow = {
	open: function () {
		if (document.documentElement.requestFullscreen) {
			document.documentElement.requestFullscreen();
		} else if (document.documentElement.webkitRequestFullscreen) {
			document.documentElement.webkitRequestFullscreen();
		} else if (document.documentElement.mozRequestFullScreen) {
			document.documentElement.mozRequestFullScreen();
		} else if (document.documentElement.msRequestFullscreen) {
			document.documentElement.msRequestFullscreen();
		}
	},
	close: function () {
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.webkitExitFullscreen) {
			document.webkitExitFullscreen();
		} else if (document.mozCancelFullScreen) {
			document.mozCancelFullScreen();
		} else if (document.msExitFullscreen) {
			document.msExitFullscreen();
		}
	},
}

document.addEventListener('DOMContentLoaded', function () {
	let isFullscreen = false;
	const toggleButton = document.querySelector('.lti-pb-toggle-fullscreen');
	const openIcon = document.querySelector('.lti-pb-open-icon');
	const closeIcon = document.querySelector('.lti-pb-close-icon');
	const footer = document.querySelector('footer');
	closeIcon.style.display = 'none';
	toggleButton.style.display = 'block';

	if (toggleButton && footer) {
		footer.style.display = 'none';
	}

	// If not in an iframe, hide the toggle button
	if (toggleButton && window.self === window.top) {
		toggleButton.style.display = 'none';
		return;
	}

	if (closeIcon) {
		closeIcon.style.display = 'none';
	}

	if (toggleButton) {
		toggleButton.addEventListener('click', function (e) {
			e.preventDefault();
			toggleFullscreen();
		});
	}

	const toggleFullscreen = function () {
		if (isFullscreen) {
			ltiPBWindow.close();
			openIcon.style.display = 'block';
			closeIcon.style.display = 'none';
		} else {
			ltiPBWindow.open();
			openIcon.style.display = 'none';
			closeIcon.style.display = 'block';
		}
	}

	document.addEventListener('fullscreenchange', function () {
		isFullscreen = !!document.fullscreenElement;
		if (isFullscreen) {
			openIcon.style.display = 'none';
			closeIcon.style.display = 'block';
		} else {
			openIcon.style.display = 'block';
			closeIcon.style.display = 'none';
		}
	});
	document.addEventListener('webkitfullscreenchange', function () {
		isFullscreen = !!document.webkitFullscreenElement;
	});
	document.addEventListener('mozfullscreenchange', function () {
		isFullscreen = !!document.mozFullScreenElement;
	});
	document.addEventListener('MSFullscreenChange', function () {
		isFullscreen = !!document.msFullscreenElement;
	});
});
